import popupService from "./popup-service";
import "core-js/stable";
import "regenerator-runtime/runtime";

export default (() => {

    const post = async (url,postData, done, fail) => {
        let responseData = {};

        const settings = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(postData) 
        };

        try {
            const response = await fetch(url, settings);
            responseData = await parseResponse(response);          

            if (!response.ok) { 
                apiCallFailure(fail, responseData.message);         
                return;
            }            
            
        } catch (e) {            
            apiCallFailure(fail, e.message);    
            return;
        }
        done(responseData);
    };


    const get = async (url, done, fail) => {   
        let responseData;

        try {
            const response = await fetch(url);
            responseData = await parseResponse(response);  

            if (!response.ok) {
                apiCallFailure(fail, responseData.message);
                return;
            }         
        }
        catch (e) {
            apiCallFailure(fail,e.message);
            return;
        }      
        
        done(responseData);
    };


    const parseResponse = async (response) => {
        const text = await response.text();
        if (text) {
            return JSON.parse(text);
        }
        return {};
    };


    const apiCallFailure = (fail, message) => {

        if (fail === null) {
            defaultFail(message);
        } else {
            fail(message);
        }
    };

    const defaultFail = (message) => {
        console.error(message);        
        popupService.renderErrorMessage("We encountered a problem contacting the server.  Please try again later.  If the problem persists please contact us.")
    }

    return {
        post,
        get,
        defaultFail
    }

})();